<div class="modal-dialog activity-source-dialog-container">
  <div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
    <div class="goreact-modal-header">
      <span></span>
      <button type="button" class="close-btn" (click)="close()" attr.aria-label="{{ 'common_close' | translate }}">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body">
      <h1 [id]="dialogTitleId" class="body-header">{{ 'assignment-source-modal-header' | translate }}</h1>
      <p class="body-subheader">
        {{ isDefaultLti ? ('assignment-source-modal-subheader-lti' | translate) : ('assignment-source-modal-subheader' | translate) }}
      </p>
      <ul class="button-div">
        <li class="button-list-item">
          <button class="icon-btn-large new-button" (click)="close(sources.NEW)" aria-labelledby="new-btn-text" data-cy="new-activity-source-btn">
            <i class="ficon-assignment"></i>
            <span id="new-btn-text" class="new-btn-text" [innerHTML]="'assignment-source-modal_button-new' | translate"></span>
          </button>
        </li>
        @if (isDefaultLti) {
          <li class="button-list-item">
            <button class="icon-btn-large previous-button" (click)="close(sources.PREVIOUS)" aria-labelledby="previous-btn-text">
              <i class="ficon-previous-assignment"></i>
              <span id="previous-btn-text" class="previous-btn-text" [innerHTML]="'assignment-source-modal_button-previous' | translate"></span>
            </button>
          </li>
        }
        <li class="button-list-item">
          <button class="icon-btn-large library-button" (click)="close(sources.LIBRARY)" aria-labelledby="library-btn-text">
            <i class="ficon-app-library"></i>
            <span id="library-btn-text" class="library-btn-text" [innerHTML]="'assignment-source-modal_button-library' | translate"></span>
          </button>
        </li>
        @if (showCreateTemplate()) {
          <li class="button-list-item">
            <button class="icon-btn-large template-button" (click)="close(sources.CREATE)" aria-labelledby="create-template">
              <i class="ficon-app-expand-plus"></i>
              <span id="create-template" class="template-btn-text" [innerHTML]="'assignment-source-modal_button-create' | translate"></span>
            </button>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
